import React from "react";
import { connect } from "react-redux";
import { TagBox, SelectBox, Button, Popup } from "devextreme-react";
import LoadingOverlay from "../../../../Shared/LoadingOverlay";
import TableFilter from "../../../../Shared/tableFilter.jsx";
import {
  getUserByComanyId,
  addUsersToRol,
  getListasPortalEmpresa,
  openCloseModalEditarRoles,
  setCurrentPageGestionRolesUsuario,
  setPageSizeGestionRolesUsuario,
  setPageEmployeeSearch,
  openCloseModalDelRoles,
} from "./actions";
import ModalEditarRoles from "./ModalEditarRoles";
import ModalDelRoles from "./ModalDeleteRoles";
import LoadingResume from "./LoadingResume";
import { push } from "connected-react-router";
import { paths } from "../../../../../config/routes";
import {
  Table,
  Loader,
  Button as ButtonRSuite,
  Checkbox,
  Grid,
  Row,
  Col
} from "rsuite";
import "rsuite/dist/styles/rsuite-default.css";
import "../../../../../css/gestion-usuarios.scss";
import CustomDataEmployee from "./CustomDataEmployee";
import EmployeeRoles from "./EmployeesRoles";
import CompanyRole from "./CompanyRole";
import ActionButton from "./ActionButton";
import DeleteButton from "./DeleteButton";
import SelectUser from "./SelectUser";
import { debounce } from "debounce";
import { getExcelFile } from '../../../../../services/userRolesApi'

const pageSizeMenu = [10, 20, 30, 40, 50, 100].map((i) => ({
  value: i,
  label: i,
}));

const ROLES_SEL = ['Administrador SEL', 'Soporte SEL']
const ROLES_CAN_EDIT = ['Admin', 'Contact Center', 'Administrador SEL', 'Soporte SEL']
const ROLES_CAN_DELETE = ['Admin']

const filterValuesMemoized = {
  text: '',
  filters: []
}

class AsignarRoles extends React.PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      workerSelected: [],
      openModal: false,
      currentPage: 1,
      pageSize: 10,
      employeesSearch: "",
      selectedAll: false,
      fullFilters: [],
      rowsFilter: [],
      filterText: '',
      filterRoles: [],
      canEdit: false,
      canDelete: false,
    };

    this.tableRef = React.createRef();
    this.props.dispatch(getListasPortalEmpresa());
  }

  componentDidMount = () => {
    if(this.props.myRoles) this.setDisplayEditRoles(this.props.myCompanyRoles)
    if(this.props.myRoles) this.setDisplayDeleteRoles(this.props.myCompanyRoles)

    if (this.props.companyId) {
      this.props.dispatch(
        getUserByComanyId(this.props.companyId, this.state.currentPage)
      );
    }
  };

  componentDidUpdate = (prevProps, prevState) => {
    if(prevProps.phase === 1 && this.props.phase === 0)
      {
        this.handleFilterChange2(filterValuesMemoized.text, filterValuesMemoized.filterValuesMemoized)
      }
    if(prevProps.employees)
      this.setState({ rowsFilter: prevProps.employees.Dataset })

    if(prevProps.rolesEmpresaFilterGestion.length > 0 && prevProps.rolesTrabajadorFilterGestion.length > 0 && prevState.fullFilters.length === 0) {
      const conditionalRolesCompany = this.handleFilterDisplay(prevProps.rolesEmpresaFilterGestion, prevProps.myCompanyRoles)
      this.setState({ fullFilters: [...prevProps.rolesTrabajadorFilterGestion, ...conditionalRolesCompany]})
    }

    if(prevState.filterText !== this.state.filterText)
      this.props.dispatch(getUserByComanyId(this.props.companyId, this.state.currentPage, this.state.pageSize, this.state.filterText, this.state.filterRoles))

    if(prevState.filterRoles !== this.state.filterRoles)
      this.props.dispatch(getUserByComanyId(this.props.companyId, this.state.currentPage, this.state.pageSize, this.state.filterText, this.state.filterRoles))


    if (prevProps.companyId !== this.props.companyId)
      this.props.dispatch(getUserByComanyId(this.props.companyId));

    if (prevProps.companyId !== this.props.companyId)
      this.props.dispatch(push(paths.root));

    if (prevState.currentPage !== this.state.currentPage) {
      this.props.dispatch(
        getUserByComanyId(
          this.props.companyId,
          this.state.currentPage,
          this.state.pageSize,
          this.state.filterText,
          this.state.filterRoles
        )
      );

      if (prevState.selectedAll)
        this.setState({ selectedAll: false, workerSelected: [] });
    }

    if (prevState.pageSize !== this.state.pageSize) {
      this.props.dispatch(
        getUserByComanyId(this.props.companyId, 1, this.state.pageSize)
      );

      this.setState({
        currentPage: 1,
      });
      if (prevState.selectedAll)
        this.setState({
          selectedAll: false,
          workerSelected: [],
        });
    } /*else if (prevState.employeesSearch !== this.state.employeesSearch) {
      this.props.dispatch(
        getUserByComanyId(
          this.props.companyId,
          1,
          10,
          this.state.employeesSearch
        )
      );
    }*/
  };

  // NOTE: filtro roles empresa
  handleFilterDisplay = (companyRoles, allRoles) => {
    const clone = [...companyRoles]
    const myRoles = this.getCompanyRoles(allRoles)
    const haveSEL = myRoles.some(r => ROLES_SEL.includes(r) || r.toLowerCase() === 'trabajador achs' || r.toLowerCase() === 'autoasignacion achs')

    if(!haveSEL) {
      const newFiltersCompany = companyRoles[0].values.filter(cr => cr.text.toUpperCase().indexOf('SEL') < 0)
      clone[0].values = newFiltersCompany
      return clone
    }
    else if(myRoles.find(r => r === ROLES_SEL[1])) {
      const newFiltersCompany = companyRoles[0].values.filter(cr => cr.text !== ROLES_SEL[0])
      clone[0].values = newFiltersCompany
      return clone
    }
    return companyRoles
  }

  handleFilterChange2 = (text, filters) => {
    filterValuesMemoized.text = text;
    filterValuesMemoized.filters = filters;

    this.setState({ filterText: text, filterRoles: (filters && filters.length > 0) ? filters.map(x => x.value.value) : [] })
    this.props.dispatch(getUserByComanyId(this.props.companyId, this.state.currentPage, this.state.pageSize, this.state.filterText, this.state.filterRoles))
  }

  exportToExcel = () => {
    getExcelFile(this.props.companyId, this.state.filterText, this.state.filterRoles, this.props.myRoles)
  }

  handleOpenModalEdit = (rowData2) => {
    this.props.dispatch(openCloseModalEditarRoles(true, rowData2));
  };

  handleOpenModalDel = (rowData2) => {
    this.props.dispatch(openCloseModalDelRoles(true, rowData2));
  };

  openModal = () => {
    this.setState({ openModal: true });
  };

  setDisplayEditRoles = allRoles => {
    const myRoles = this.getCompanyRoles(allRoles)
    const allowed = myRoles?.find(role => (role === 'Trabajador ACHS' && ROLES_CAN_EDIT.includes(role)) || ROLES_CAN_EDIT.includes(role))
    this.setState({ canEdit: Boolean(allowed)})
  }

  getCompanyRoles = roles => {
    const item = Object.keys(roles).find(r => r === this.props.companyId?.toLowerCase())
    return roles[item]
  }

  handleCancel = () => {
    this.setState({ openModal: false });
  };

  handleWorkerSelect = (isChecked, rowData) => {
    let { workerSelected } = this.state;
    if (!workerSelected) workerSelected = [];
    if (isChecked) {
      this.setState({
        workerSelected: [...workerSelected, rowData],
      });
    } else {
      this.setState({
        workerSelected: [
          ...workerSelected.filter((s) => s.Rut !== rowData.Rut),
        ],
      });
    }
  };

  handleSearchUser = debounce((value) => {
    this.setState({ employeesSearch: value || "" });
    this.props.dispatch(setPageEmployeeSearch(value));
  }, 800);

  handleSelectAll = (_, isChecked) => {
    this.setState({
      workerSelected: isChecked ? [...this.props.employees.Dataset] : [],
      selectedAll: isChecked,
    });
  };

  selectRol(e, value) {
    switch (e.element.id) {
      case "rolCmbx": {
        this.setState({ selectedRoleId: value });
        break;
      }
      default:
        break;
    }
  }

  handleTagDeleteWorker = (e) => {
    this.setState({ workerSelected: e.value });
  };

  asignMassiveRoles = () => {
    const workers = [];
    // Busco aquellos workers que no tengan el rol elegido
    this.state.workerSelected.forEach((t) => {
      if (
        t.Roles.some((elem) => elem === this.state.selectedRoleId) === false
      ) {
        workers.push({
          Rut: t.Rut,
          RelationTypeCode: t.RelationTypeCode,
        });
      }
    });
    if (workers.length > 0) {
      this.props.dispatch(
        addUsersToRol({
          IdRol: this.state.selectedRoleId,
          users: workers,
          CompanyRut: this.props.companyId,
        })
      );

      this.setState({ workerSelected: null, openModal: false });
    }
  };

  setDisplayDeleteRoles = allRoles => {
    const myRoles = this.getCompanyRoles(allRoles)
    const allowed = myRoles?.find(role => (role === 'Admin' && ROLES_CAN_DELETE.includes(role)) || ROLES_CAN_DELETE.includes(role))
    this.setState({ canDelete: Boolean(allowed)})
  }

  renderAsignacionRoles = () => (
    <div>
      <div className="row zero formDenunicas">
        <div className="col-12" style={{ marginBottom: 10 }}>
          <span>Trabajadores seleccionados</span>
          <div className="content-roles-sel">
            <TagBox
              onInitialized={(e) => {
                e.component.option("openOnFieldClick", false);
              }}
              dataSource={this.state.workerSelected}
              searchEnabled={false}
              displayExpr="EmployeeName"
              multiline
              onValueChanged={this.handleTagDeleteWorker}
              value={this.state.workerSelected}
            />
          </div>
        </div>
        <div className="col-12" style={{ marginBottom: 10 }}>
          <span>Roles</span>
          <SelectBox
            id="rolCmbx"
            placeholder="Seleccione .."
            dataSource={this.props.roles}
            onValueChanged={(data) => this.selectRol(data, data.value)}
            displayExpr="Name"
            valueExpr="Id"
            searchEnabled
          />
        </div>
      </div>
      <div className="button-row">
        <div>
          <Button text="Cancelar" onClick={this.handleCancel} />
        </div>
        <div>
          <Button
            text="Asignar"
            type="success"
            onClick={this.asignMassiveRoles}
          />
        </div>
      </div>
    </div>
  );

  render() {
    const { Column, HeaderCell, Cell, Pagination } = Table;
    const { workerSelected, employeesSearch, selectedAll } = this.state;

    return (
      <div>
        {this.props.isLoading && !this.props.isOpenModalEditarRoles && !this.props.isOpenModalDelRoles &&(
          <LoadingOverlay />
        )}
        <ModalEditarRoles />
        <ModalDelRoles />
        <LoadingResume />
        {/*         {this.props.isLoading && !this.props.isOpenModalDelRoles && (
          <LoadingOverlay />
        )}
        <DeleteModal />
        <LoadingResume />
        */}

        {this.props.roles ? (
          <React.Fragment>
            {this.props.companyId ? (
              <>
                <Grid fluid>
                  <Row className="show-grid">
                    <Col xs={workerSelected?.length > 0 ? 20 : 24}>
                      <TableFilter
                        placeholder={'Buscar trabajador por nombre o rut'}
                        show={true}
                        filters={this.state.fullFilters}
                        onChange={this.handleFilterChange2}
                        buttons={
                            {
                              filter: { buttonName: "iconFilter", visible: true, buttonAction: null },
                              document: { buttonName: "iconDocument", visible: false, buttonAction: null },
                              download: {
                                buttonName: "iconDownload", visible: true, buttonAction: this.exportToExcel, active: false,
                              },
                              newItem: { buttonName: "custom", visible: false, buttonAction: null },
                            }
                        }
                      />
                    </Col>

                    <Col xs={4}>
                      {workerSelected?.length > 0 && (
                        <ButtonRSuite
                          style={{ marginLeft: "10px" }}
                          onClick={this.openModal}
                          color="cyan"
                        >
                          Asignar roles
                        </ButtonRSuite>
                      )}
                    </Col>
                  </Row>
                </Grid>

                <Table
                  height={520}
                  wordWrap
                  hover={false}
                  data={this.state.rowsFilter}
                  // data={!this.props.employees ? [] : this.props.employees.Dataset}
                  //data={!employeesSearch ? [] : employeesSearch}
                  //loading={loading && state !== "hasValue"}
                  renderLoading={() => {
                    return (
                      <div className="rs-table-loader-wrapper">
                        <div className="rs-table-loader">
                          <Loader
                            speed="slow"
                            size="md"
                            content="Cargando Lista"
                          />
                        </div>
                      </div>
                    );
                  }}
                  // renderRowExpanded={(rowData) => <div>Hola</div>}
                >
                  {/*<Column flexGrow={0.25}>
                    <HeaderCell>
                      <Checkbox
                        onChange={this.handleSelectAll}
                        checked={selectedAll}
                      />
                    </HeaderCell>
                    <SelectUser
                      handleWorkerSelect={this.handleWorkerSelect}
                      workerSelected={this.state.workerSelected}
                    />
                </Column>*/}
                  <Column flexGrow={1}>
                    <HeaderCell>Usuario</HeaderCell>
                    <CustomDataEmployee />
                  </Column>
                  <Column flexGrow={1}>
                    <HeaderCell>Roles Trabajador</HeaderCell>
                    <EmployeeRoles />
                  </Column>
                  <Column flexGrow={1}>
                    <HeaderCell>Roles Empresa</HeaderCell>
                    <CompanyRole />
                  </Column>

                  {this.state.canEdit ? (
                    <Column flexGrow={0.5}>
                      <HeaderCell>Editar usuario</HeaderCell>
                      <ActionButton
                        text="Editar"
                        type="success"
                        handleEdit={this.handleOpenModalEdit}
                      />
                    </Column>
                  ) : null}
                  {this.state.canDelete ? (
                  <Column flexGrow={0}>
                  <HeaderCell> </HeaderCell>
                      <DeleteButton
                        text="Eliminar"
                        type="danger"
                        handleEdit={this.handleOpenModalDel}
                      />
                    </Column>
                  ): null}
                </Table>

                <Pagination
                  lengthMenu={pageSizeMenu}
                  activePage={this.state.currentPage}
                  displayLength={this.state.pageSize}
                  total={
                    !this.props.employees ? 10 : this.props.employees.Count
                  }
                  style={{ fontSize: "14px" }}
                  renderTotal={(total, activePage) => {
                    const { pageSize } = this.state;
                    const lengthData =
                      this.props.employees && this.props.employees.Count;
                    const pagesCount = lengthData / pageSize;
                    let resto = pagesCount % 1;
                    const totalPage =
                      resto < 0.5
                        ? Math.round(pagesCount) + 1
                        : Math.round(pagesCount);

                    return (
                      <span className="text">{`Página ${activePage} de ${totalPage} (${total} ítems)`}</span>
                    );
                  }}
                  onChangePage={(currentPage) => {
                    this.setState({ currentPage });
                    this.props.dispatch(
                      setCurrentPageGestionRolesUsuario(currentPage)
                    );
                  }}
                  onChangeLength={(pageSize) => {
                    this.setState({ pageSize });
                    this.props.dispatch(
                      setPageSizeGestionRolesUsuario(pageSize)
                    );
                    this.props.dispatch(setCurrentPageGestionRolesUsuario(1));
                  }}
                />
              </>
            ) : (
              // <DataGrid
              //   showBorders={false}
              //   dataSource={this.props.employees}
              //   className="custom-table"
              //   showColumnLines={false}
              //   showRowLines={false}
              //   selectedRowKeys={this.state.workerSelected}
              //   rowAlternationEnabled
              //   noDataText="Sin Trabajadores"
              //   ref={(ref) => {
              //     if (ref !== null) this.tableRef = ref.instance;
              //   }}
              //   loadPanel={{
              //     enabled: false,
              //   }}
              //   onSelectionChanged={this.handleWorkerSelect}
              // >
              //   <HeaderFilter visible />
              //   <Sorting mode="multiple" />
              //   <Scrolling columnRenderingMode="virtual" />

              // <Selection
              //   showCheckBoxesMode="always"
              //   mode="multiple"
              //   allowSelectAll={false}
              // />
              //   {/* <Column
              //       caption="Trabajador"
              //       allowSelectAll={false}
              //       dataField="EmployeeName"
              //       visible={false}
              //     />
              //     <Column
              //       dataField="Rut"
              //       allowSelectAll={false}
              //       visible={false}
              //     /> */}

              //   <Column
              //     allowSearch
              //     caption="Usuario"
              //     calculateCellValue={(rowData) =>
              //       `${rowData.EmployeeName} ${rowData.Rut}`
              //     }
              //     cellTemplate={(element, row) => {
              //       ReactDOM.render(
              //         <UserInfoColumn
              //           nombre={`${row.data.EmployeeName}`}
              //           rut={row.data.Rut}
              //         />,
              //         element
              //       );
              //     }}
              //   />

              //   <Column
              //     // dataField="Relation"
              //     calculateCellValue={(rowData) =>
              //       `${
              //         rowData.Roles && rowData.Roles.find((r) => r.Id === 6)
              //           ? rowData.Roles.find((r) => r.Id === 6).Name
              //           : rowData.Roles && rowData.Roles.find((r) => r.Id === 8)
              //           ? rowData.Roles.find((r) => r.Id === 8).Name
              //           : ""
              //       }`
              //     }
              //     caption="Roles Trabajador"
              //     allowSearch
              //     allowEditing={false}
              //     allowFiltering={false}
              //   />

              //   <Column
              //     dataField="Roles"
              //     caption="Roles Empresa"
              //     allowSearch
              //     allowFiltering={false}
              //     dataType="string"
              //     calculateCellValue={(rowData) =>
              //       rowData.Roles.filter((r) => r.Id !== 6 && r.Id !== 8)
              //         .map((e) => (e.Name ? e.Name : e.Description))
              //         .join(", ")
              //     }
              //     filterOperations="contains"
              //     headerFilter={{
              //       dataSource: this.props.rolesFilter,
              //     }}
              //   />
              //   <Column
              //     alignment="right"
              //     cellTemplate={(element, row) => {
              //       ReactDOM.render(
              //         <ActionButton
              //           text="Editar"
              //           type="success"
              //           onClick={() => this.handleOpenModalEdit(row)}
              //         />,
              //         element
              //       );
              //     }}
              //   />

              //   <Paging pageSize={10} />
              //   <Pager showInfo />
              // </DataGrid>
              "DEBE ELEGIR UNA EMPRESA"
            )}
            <br />
            <span style={{ paddingBottom: "1vh", fontSize: "14px" }}>
              *En esta tabla podrás visualizar a todos los usuarios registrados
              en ACHS Virtual de tu empresa y editarle los permisos si así lo
              deseas. Recuerda que si la columna roles está vacía, significa que
              ese usuario solo tiene permisos relacionados a sus funcionalidades
              como trabajador.&nbsp;
              <a
                href="https://www.achs.cl/portal/Paginas/Soporte_Achs_Virtual.aspx"
                target="_blank"
                rel="noopener noreferrer"
                className="text-button dx-button-mode-contained dx-button-success"
              >
                <span>Más información</span>
              </a>
            </span>
            <Popup
              visible={this.state.openModal}
              dragEnabled={false}
              maxHeight="325px"
              onHiding={this.handleCancel}
              maxWidth="500px"
              title="Asignar Roles"
              showTitle
              contentRender={() => <div>{this.renderAsignacionRoles()}</div>}
            />
          </React.Fragment>
        ) : null}
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  companyId: state.global.companyId,
  sucursalId: state.global.sucursalId,
  userAccessIds: state.global.userAccessIds,
  phase: state.asignacionRoles.phase,
  roles: state.asignacionRoles.roles,
  employees: state.asignacionRoles.employees,
  isLoading: state.asignacionRoles.isLoading,
  isOpenModalEditarRoles: state.asignacionRoles.isOpenModalEditarRoles,
  rolesFilter: state.asignacionRoles.rolesFilter,
  rolesTrabajadorFilterGestion: state.asignacionRoles.rolesTrabajadorFilterGestion,
  rolesEmpresaFilterGestion: state.asignacionRoles.rolesEmpresaFilterGestion,
  myRoles: state.global.myRoles,
  myCompanyRoles: state.global.myCompanyRoles,
  isOpenModalDelRoles: state.asignacionRoles.isOpenModalDelRoles,
});

const mapDispatchToProps = (dispatch) => ({
  // dispatch: (action) => {
  //   dispatch(action);
  // },
  dispatch
});

export default connect(mapStateToProps, mapDispatchToProps)(AsignarRoles);
